/** Should request data in chunks of 14 items */
export const HP_GALLERY_REQUEST_CHUNKS = 14

/** Number of carousel slides to show per device */
export const SLIDES_PER_DEVICE = { DESKTOP: 5, TABLET: 4, MOBILE: 2 } as const
